module.exports = __webpack_public_path__ + "img/career.ca36b762.png";